angular.module('cfn').service('notificationService', notificationService);

notificationService.$inject = ['$rootScope', '$timeout', '$q', '$http'];

function notificationService($rootScope, $timeout, $q, $http) {
  'use strict';

  var POLLING_INTERVAL = 20000;
  var pollingHttpStatus;
  var isAbEnabled = function() {
    return _.isObject(window.features);
  };

  var services = {
    UNREAD_FIELD_BOOKINGS: {
      state: { count: 0 },
      poll: function() {
        return $http
          .get('/365FarmNet/mod/booking-service/reporting/rest/v1.0/booking/count/unread')
          .then(function(result) {
            return parseInt(result.data);
          })
          .catch(function(e) {
            pollingHttpStatus = parseInt(e.status);
            if (pollingHttpStatus >= 200) {
              services.UNREAD_FIELD_BOOKINGS.failed = true;
            }
            console.error('countUnread request failed with error', e);
          });
      }
    }
  };

  var pollingStates = {};
  var timer = $timeout(pollAll, POLLING_INTERVAL);
  function pollAll() {
    //console.log('polling loop');
    var resultPromises = {};
    var now = new Date().getTime(),
      interval = POLLING_INTERVAL;
    if (isAbEnabled() && window.features.notificationServicePollingInterval) {
      interval =
        parseInt(window.features.notificationServicePollingInterval) * 1000;
    }

    _.each(pollingStates, function(pollingState, name) {
      //call service only if it makes sense
      if (
        services[name] &&
        !services[name].failed &&
        pollingState.listeners.length > 0 &&
        now - pollingState.lastPoll > interval
      ) {
        pollingState.lastPoll = now;
        //console.log('polling:' + name);
        resultPromises[name] = services[name].poll().then(function(result) {
          //we might check if those values are equal, and in such case return
          pollingState.lastValue = result;
          _.each(pollingState.listeners, function(fn) {
            fn(result);
          });
        });
      } else {
        resultPromises[name] = $q.resolve(pollingState.lastValue);
      }
    });

    $timeout.cancel(timer);
    timer = $timeout(pollAll, interval);

    return resultPromises;
  }

  //clean all pollers when changing routes (they have to register again)
  $rootScope.$on('$routeChangeStart', function() {
    _.each(pollingStates, function(polligState) {
      polligState.listeners = [];
    });
    $timeout.cancel(timer);
    timer = null;
  });

  /** Checks if the provided service and name is acceptable */
  function isServiceValid(name, service) {
    var error = '';
    if (services[name]) {
      error += 'Service already registered with that name\n';
    }
    if (!angular.isFunction(service.poll)) {
      error += 'Service must implement poll interface and return a promise\n';
    }
    if (error.length > 0) {
      console.log(error);
      return false;
    }
    return true;
  }

  /** Registers a valid service which must implement poll()->promise */
  this.register = function(name, service) {
    if (isServiceValid(name, service)) {
      services[name] = service;
      if (pollingStates[name] && pollingStates[name].listeners.length > 0) {
        //if we had listeners before retrigger polling (it takes care not to call other services too soon.
        pollAll();
      }
      return true;
    }
    return false;
  };

  /** map of service names (function to allow dynamic registration) */
  this.services = function() {
    return _.mapObject(services, function(_, name) {
      return name;
    });
  };

  /** start polling for this service and (if provided) call onChangeFn in case of changes */
  this.subscribe = function(serviceName, onChangeFn) {
    if (!pollingStates[serviceName]) {
      pollingStates[serviceName] = { listeners: [], lastPoll: 0 };
    }
    if (pollingStates[serviceName].listeners.indexOf(onChangeFn) === -1) {
      //add function to listeners if any
      if (onChangeFn) {
        pollingStates[serviceName].listeners.push(onChangeFn);
      }
      if (services[serviceName] && onChangeFn) {
        //if it's already defined, retrieve immediately whatever the service has.
        var lastServiceValue = pollingStates[serviceName].lastValue;
        if (!_.isUndefined(lastServiceValue)) {
          onChangeFn(lastServiceValue);
        }
        pollAll();
      }
    }
  };

  this.forcePolling = function(serviceName) {
    if (pollingStates[serviceName]) {
      pollingStates[serviceName].lastPoll = 0;
      return pollAll()[serviceName];
    }
  };
}

export default notificationService;
